import { initStore }    from '../src/store';
import withRematch      from '../src/utils/withRematch';
import Layout           from '../src/containers/MineLayout';
import CarPark           from '../src/containers/CarPark';

const CarParkPage = (props) => {
    const { lang } = props;

    return (
        <Layout {...props}>
            <CarPark lang={lang}/>
        </Layout>
    );
};

CarParkPage.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});


    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: '',
        curLang,
        pathname,
        title: 'MOVER: Автопарк',
        description: 'Автопарк MOVER — это грузовики вместимостью от 0,6 до 3 тонн. Прошедшие контроль качества сервиса MOVER, не старше 2012 года, в идеальном техническом состоянии. Для перевозки вашего груза, доступны типы кузова подходящие специально для вас - Цельнометаллический, Фургон, Тент, Рефрижератор, Изотерм, Бортовой, Автомобили с гидробортом...'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(CarParkPage);
